import { useState } from "react";
import { motion } from "framer-motion";
import { PlusCircle, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const monthName = () => {
  const d = new Date();
  const m = d.toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  return m.charAt(0).toUpperCase() + m.slice(1);
};

export const StartScreen = ({ username, onStart, hasPrevious, onHistory }) => {
  const [name, setName] = useState(`Inventaire ${monthName()}`);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setLoading(true);
    await onStart(name.trim());
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="relative rounded-3xl overflow-hidden mb-5 h-40 border border-border">
          <img
            src="https://images.unsplash.com/photo-1514933651103-005eec06c04b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            alt="Bar"
            className="w-full h-full object-cover opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0D0E12] via-[#0D0E12]/40 to-transparent" />
          <div className="absolute bottom-4 left-5">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary/20 border border-primary/30 px-3 py-1 text-xs font-bold text-primary">
              <Sparkles className="h-3.5 w-3.5" /> Bonjour {username}
            </span>
          </div>
        </div>

        <div className="rounded-3xl border border-border bg-card p-7 shadow-2xl">
          <h2 className="font-display text-2xl font-extrabold tracking-tight mb-1">
            {hasPrevious ? "Nouvel inventaire" : "Démarrer l'inventaire"}
          </h2>
          <p className="text-sm text-muted-foreground mb-5">
            Le catalogue de boissons est pré-rempli. Vous pourrez ajouter des produits à tout moment.
          </p>
          <form onSubmit={submit}>
            <Label
              htmlFor="invname"
              className="text-xs uppercase tracking-wider text-muted-foreground"
            >
              Nom de l'inventaire
            </Label>
            <Input
              id="invname"
              data-testid="new-inventory-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-2 h-14 text-base rounded-2xl bg-secondary border-border"
            />
            <Button
              type="submit"
              data-testid="start-inventory-btn"
              disabled={loading || !name.trim()}
              className="mt-5 w-full h-14 rounded-2xl text-base font-bold gap-2 active:scale-95 transition-transform"
            >
              <PlusCircle className="h-5 w-5" />
              {loading ? "Création…" : "Démarrer le comptage"}
            </Button>
            {onHistory && (
              <button
                type="button"
                data-testid="start-history-btn"
                onClick={onHistory}
                className="mt-3 w-full text-sm text-muted-foreground hover:text-foreground underline underline-offset-4"
              >
                Voir les inventaires précédents
              </button>
            )}
          </form>
        </div>
      </motion.div>
    </div>
  );
};
